import classNames from 'classnames';
import React, {useCallback, useState} from 'react';
import {FilterNodeTypeNumberRange} from 'src/js/containers/filtering';
import {DynamicFilter, FILTER_TYPE_NUMBER_RANGE, Filter} from 'src/js/lib/filtering';
import {FilterNode} from 'src/js/model/filters_config';

import lightFilterNodeStyles from './LightFilterNodeStyles.less';
import {NumberRangeFilterConfig, useFormatters} from './LightFormatter';

type NumberRange = {start: number; end: number};
type Props = {
  config: NumberRangeFilterConfig;
  value: NumberRange | null | undefined;
  onChange?: (newValue: NumberRange | null) => void;
};
export const LightNumberRangeFilter: React.FC<Props> = (props) => {
  const {config: _config, value, onChange} = props;
  const filterType = FILTER_TYPE_NUMBER_RANGE;
  const {t} = useFormatters();
  const config = {
    ..._config,
    ui: {
      label: t(_config.ui.label),
      type: filterType,
      // The slider bounds the caller fetched (the "properties" maxima); without them the slider falls back to 0-100
      // and clamps anything typed above 100, which hides e.g. every patient older than 100.
      min: _config.ui.min,
      max: _config.ui.max,
    },
  };
  const [isOpened, setIsOpened] = useState(false);
  const toggleOpened = useCallback(() => {
    setIsOpened((v) => !v);
  }, []);
  const NumberRangeFilter = DynamicFilter.getFilterClass(filterType);
  const filter = value
    ? new NumberRangeFilter({
        type: filterType,
        property: config.name,
        value: [value.start, value.end],
      })
    : undefined;
  const changeFilter = useCallback(
    (newFilter: Filter) => {
      const [start, end] = newFilter.getValue();
      if (onChange) onChange({start, end});
    },
    [onChange]
  );
  const removeFilter = useCallback(
    (_newFilter: Filter) => {
      if (onChange) onChange(null);
    },
    [onChange]
  );
  const inputRef = useCallback(() => {
    // do nothing
  }, []);
  const setFocus = useCallback(() => 0, []);
  const node = new FilterNode(config);
  return (
    <span className={classNames(lightFilterNodeStyles.dlFilterNodeContent, 'dlFilterNode')} data-name={config.name}>
      <FilterNodeTypeNumberRange
        node={node}
        isOpened={isOpened}
        toggleOpened={toggleOpened}
        changeFilter={changeFilter}
        removeFilter={removeFilter}
        selectedFilter={filter}
        inputRef={inputRef}
        setFocus={setFocus}
      />
    </span>
  );
};
